// extracted by mini-css-extract-plugin
export var filterIncDec = "_92-0";
export var leftBorder = "_92-1";
export var rightBorder = "_92-2";
export var stringInput = "_92-3";